module.exports = __webpack_public_path__ + "img/energy-control.2670867f.png";